export const ASSETS_TABLE = 'Assets table';
